/**
 * Pins a page's primary action to the bottom of the screen on a phone, in the
 * same bar the policy and claim journeys use: white, a hairline on top, 12px
 * above, 16px either side, and a bottom inset that clears the home indicator.
 * On larger screens, or with `pinned={false}`, the action stays in the flow
 * exactly where it was.
 *
 * The bar leaves a spacer of its own height behind, so the last field on the
 * page can always scroll clear of it.
 */
const StickyActionBar = ({ children, pinned = true }) => {
  if (!pinned) return children;
  return (
    <>
      <div aria-hidden="true" className="hidden max767:block h-[108px]" />
      <div className="max767:fixed max767:inset-x-0 max767:bottom-0 max767:z-20 max767:bg-white max767:border-t max767:border-[#E5E9EB] max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] [&_.primary-button]:max767:mb-0">
        {children}
      </div>
    </>
  );
};

export default StickyActionBar;
